import { render, staticRenderFns } from "./PlaqueRecord.vue?vue&type=template&id=b840d7a4&scoped=true"
import script from "./PlaqueRecord.vue?vue&type=script&lang=js"
export * from "./PlaqueRecord.vue?vue&type=script&lang=js"
import style0 from "./PlaqueRecord.vue?vue&type=style&index=0&id=b840d7a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b840d7a4",
  null
  
)

export default component.exports